import { useLocation } from "react-router-dom";
import { useContact } from "@/hooks/useContact";

function WhatsAppIcon({ className = "h-7 w-7" }) {
  return (
    <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
      <path d="M16.04 3C9.4 3 4 8.36 4 14.96c0 2.3.66 4.54 1.9 6.47L4 29l7.77-2.03a12.1 12.1 0 0 0 4.27.78h.01C22.67 27.75 28 22.39 28 15.79 28 9.2 22.67 3 16.04 3Zm0 22.7h-.01c-1.33 0-2.64-.36-3.79-1.03l-.27-.16-4.6 1.2 1.23-4.47-.18-.29a9.9 9.9 0 0 1-1.53-5.3c0-5.47 4.46-9.92 9.96-9.92 5.48 0 9.94 4.45 9.94 9.92-.01 5.6-4.47 10.05-9.75 10.05Zm5.46-7.43c-.3-.15-1.77-.87-2.04-.97-.28-.1-.48-.15-.68.15-.2.3-.78.97-.96 1.17-.18.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.76-1.66-2.06-.17-.3-.02-.46.13-.61.14-.13.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.68-1.63-.93-2.23-.24-.58-.49-.5-.68-.51h-.58c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48 0 1.47 1.07 2.88 1.22 3.08.15.2 2.1 3.2 5.08 4.48.71.31 1.27.49 1.7.63.72.23 1.37.2 1.88.12.57-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35Z" />
    </svg>
  );
}

export function FloatingCTA() {
  const CONTACT = useContact();
  const lifted = useLocation().pathname.startsWith("/trips/");
  return (
    <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" data-testid="floating-whatsapp-btn" aria-label="Chat with us on WhatsApp"
      className={`ripple fixed right-4 sm:right-6 z-40 grid place-items-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-300 hover:-translate-y-1 ${lifted ? "bottom-24 lg:bottom-5" : "bottom-5"}`}>
      <WhatsAppIcon />
    </a>
  );
}
